import {
    read_deduped_timeline_events,
    read_text_deduped_timeline_events,
    read_timeline_events,
    read_timeline_plain_text,
    read_timeline_text,
    read_timeline_text_key,
    read_timeline_type
} from '../../../../utils/timeline/timeline_normalization';
import { read_timeline_event_groups } from '../../../../utils/timeline/timeline_grouping';

export const timelineGroupingWindowMilliseconds = 60 * 1000;

export {
    read_timeline_plain_text,
    read_timeline_text,
    read_timeline_text_key,
    read_timeline_type
};

const activeSessionPlaceholderSellers = new Set([
    'system',
    'unknown seller',
    'unknown contract seller'
]);

// Keeps the temporary block tied to a real assigned seller rather than an unowned board card.
const read_active_sass_session_seller = (offerItem = {}, session = {}) => {
    return [
        session.seller,
        session.caller,
        offerItem.sassAssignee,
        session.currentCaller
    ].map((seller) => {
        return seller && typeof seller === 'object' ? seller : { name: seller };
    }).find((seller) => {
        const identities = [
            seller.userId,
            seller.id,
            seller._id,
            seller.email,
            seller.username,
            seller.name,
            seller.label,
            seller.displayName
        ].map((identity) => `${identity || ''}`.trim()).filter(Boolean);

        return identities.length && identities.some((identity) => {
            return !activeSessionPlaceholderSellers.has(identity.toLowerCase());
        });
    }) || null;
};

// Builds the UI-only card for the seller tenure that has not reached a terminal outcome.
export const read_active_sass_session_event = (offerItem = {}) => {
    const session = offerItem?.sassSession || {};
    const sessionId = `${session.sessionId || ''}`.trim();
    const seller = read_active_sass_session_seller(offerItem, session);
    const sessionEnded = [
        session.closedAt,
        session.outcome,
        session.boundaryReason
    ].some((value) => `${value || ''}`.trim().length);

    if (!sessionId.length
        || !seller
        || sessionEnded
        || offerItem.deleted === true
        || offerItem.actualPaid === true) {
        return null;
    }

    const sourceKey = `active-sass-session:${sessionId}`;

    return {
        eventId: sourceKey,
        sourceKey,
        sourceApp: 'godfather',
        sourceEntity: 'sass_session',
        type: 'SASS_SESSION',
        changedAt: session.updatedAt || offerItem.updatedAt || session.openedAt || '',
        acceptedAt: '',
        by: seller,
        from: {
            status: session.openedStatus || '',
            openedAt: session.openedAt || ''
        },
        to: {
            status: session.currentStatus || ''
        },
        note: '',
        data: {
            ...session,
            seller,
            caller: seller,
            active: true
        },
        duplicateSourceIds: []
    };
};

// Normalizes authoritative pages and legacy SASS rows through the shared contract.
export const read_sass_timeline_events = (rows = []) => {
    return read_timeline_events(rows);
};

// Reads retained local rows only while a historical SASS card has no Brand link.
export const read_sass_timeline_fallback = (offerItem = {}) => {
    const comments = [
        ...(offerItem.comments || []),
        ...(offerItem.niffler?.comments || []),
        ...(offerItem.typesData?.comments || [])
    ].map((comment) => ({
        ...comment,
        type: 'comment',
        note: comment.body || comment.html || comment.comment || comment.text,
        sourceApp: comment.sourceApp || 'godfather',
        sourceEntity: comment.sourceEntity || 'sass'
    }));
    const rows = [
        ...(offerItem.timeline || []),
        ...(offerItem.niffler?.timeline || []),
        ...(offerItem.typesData?.sassTimeline || []),
        ...(offerItem.statusline || []),
        ...comments
    ];

    return read_timeline_events(rows);
};

// Recomputes exact and text duplicates after every appended cursor page.
export const merge_sass_timeline_pages = (...eventLists) => {
    return read_text_deduped_timeline_events(read_deduped_timeline_events(
        eventLists.flatMap((events) => events || [])
    ));
};

// Keeps the page utility API while delegating display grouping to shared logic.
export const read_sass_timeline_groups = (events = []) => {
    return read_timeline_event_groups(events);
};
